import axios, {AxiosResponse} from 'axios'
import endpoints from '../../endpoints'
import {DailyTripAPIData, StudentDailyTripAPIData} from '../../ts/trip'
import {APIResponse} from '../../../types/type'

const API_URL = process.env.REACT_APP_API_URL

interface DailyTripAPIResponse {
  data: DailyTripAPIData[]
  status: boolean
  message: string
}

export async function fetchDailyTrips(date: string): Promise<APIResponse<DailyTripAPIData[]>> {
  try {
    const response = await axios.put<APIResponse<DailyTripAPIData[]>>(
      `${API_URL}${endpoints.busLocation.list}`,
      {
        dateby: date, // Payload for the request.
      }
    )

    // Validate response status and structure.
    if (response.status === 200 && response.data?.status && Array.isArray(response.data.data)) {
      return response.data // Return the data array.
    } else {
      throw new Error(
        `Unexpected response format or status. Status: ${response.status}, Message: ${
          response.data?.message || 'Unknown'
        }`
      )
    }
  } catch (error) {
    // Enhanced error handling: log errors and rethrow with additional context.
    console.error('Error fetching daily trips:', error)
    throw new Error(
      `Failed to fetch daily trips: ${error instanceof Error ? error.message : 'Unknown error'}`
    )
  }
}

export async function fetchStudentDailyTrip(
  daily_trip_id: string | number
): Promise<APIResponse<StudentDailyTripAPIData[]>> {
  try {
    const response = await axios.get(
      `${API_URL}${endpoints.student.studentDailyTrip}${daily_trip_id}`
    )

    return response.data
  } catch (error) {
    throw error
  }
}
